<template>
  <div>
    <!-- Header -->
    <div class="pa-4 d-flex justify-space-between align-center">
      <Breadcrumbs headline="Mã đề thi" :link="[{ text: 'Mã đề thi', href: '../exam-variant' }]" />

      <v-btn depressed dark color="primary" @click="newDialog = !newDialog">
        <v-icon left>mdi-plus</v-icon>Thêm mã đề thi
      </v-btn>
    </div>

    <!-- Bộ lọc -->
    <v-card outlined class="pa-6 mb-6 elevation-0">
      <ExamVariantFilter @onFilterChanged="onFilterChanged" />
    </v-card>

    <!-- View -->
    <div v-if="action.state === 'select'" class="elevation-0">
      <StudentBlankView />
    </div>
    <div v-else>
      <ExamVariantTable
        :query="query"
      />
    </div>

    <!-- Dialog tạo mới -->
    <CreateExamVariantForm
      :state="newDialog"
      @updated="handleAfterCreate"
    />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import StudentBlankView from '@/components/basic/StudentBlankView.vue'
import ExamVariantFilter from '@/modules/exam/ExamVariantFilter.vue'
import ExamVariantTable from '@/modules/exam/ExamVariantTable.vue'
import CreateExamVariantForm from '@/modules/exam/CreateExamVariantForm.vue'

export default {
  components: {
    StudentBlankView,
    ExamVariantFilter,
    ExamVariantTable,
    Breadcrumbs,
    CreateExamVariantForm
  },
  data() {
    return {
      newDialog: false,
      action: { state: 'select' },
      exams: [],
      subjects: [],
      subjectGroups: [],
      examVariant: [],
      query: {},
      examCode: ''
    }
  },
  methods: {
    onFilterChanged(params, exams, subjects, subjectGroups, examCode) {
      this.action.state = 'filtered'
      this.query = params
      this.exams = exams
      this.subjects = subjects
      this.subjectGroups = subjectGroups
      this.examCode = examCode
    },
    refresh() {
      this.$emit('refresh')
    },
    handleAfterCreate() {
      this.onFilterChanged(
        this.query,
        this.exams,
        this.subjects,
        this.subjectGroups,
        this.examCode
      )
    }
  }
}
</script>
